




import {Vue, Component} from 'vue-property-decorator'

import AccountWithdrawal from '@/components/AccountWithdrawal.vue'

@Component({
  components: {
      AccountWithdrawal
  }
})
export default class AccountWithdrawalView extends Vue {
}
